import { copyText } from 'src/constants/copy/copy.utils';

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_PAGE_TITLE = {
    defaultMessage: 'Trip Analyzer',
    id: 'TRIP_ANALYZER.PAGE_TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_SERVICE_DATE_LABEL = {
    defaultMessage: 'Service date',
    id: 'TRIP_ANALYZER.QUERY.SERVICE_DATE_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_ROUTE_LABEL = {
    defaultMessage: 'Route',
    id: 'TRIP_ANALYZER.QUERY.ROUTE_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_DIRECTION_LABEL = {
    defaultMessage: 'Direction',
    id: 'TRIP_ANALYZER.QUERY.DIRECTION_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_LABEL = {
    defaultMessage: 'Trip',
    id: 'TRIP_ANALYZER.QUERY.TRIP_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_PARTNER_LABEL = {
    defaultMessage: 'Jurisdiction',
    id: 'TRIP_ANALYZER.QUERY.PARTNER_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_ALL_PARTNERS_OPTION = {
    defaultMessage: 'All jurisdictions',
    id: 'TRIP_ANALYZER.QUERY.ALL_PARTNERS_OPTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_SELECT_ROUTE_PLACEHOLDER = {
    defaultMessage: 'Select a route',
    id: 'TRIP_ANALYZER.QUERY.SELECT_ROUTE_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_SELECT_DIRECTION_PLACEHOLDER = {
    defaultMessage: 'Select a direction',
    id: 'TRIP_ANALYZER.QUERY.SELECT_DIRECTION_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_SELECT_TRIP_PLACEHOLDER = {
    defaultMessage: 'Select a trip',
    id: 'TRIP_ANALYZER.QUERY.SELECT_TRIP_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_SELECT_PARTNER_PLACEHOLDER = {
    defaultMessage: 'All jurisdictions',
    id: 'TRIP_ANALYZER.QUERY.SELECT_PARTNER_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TABLE_CONTROLS_LABEL = {
    defaultMessage: 'Table controls',
    id: 'TRIP_ANALYZER.TIMELINE.TABLE_CONTROLS_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TABLE_LEGEND_LABEL = {
    defaultMessage: 'Table legend',
    id: 'TRIP_ANALYZER.TIMELINE.TABLE_LEGEND_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TABLE_VIEW_OPTIONS_LABEL = {
    defaultMessage: 'Table view options',
    id: 'TRIP_ANALYZER.TIMELINE.TABLE_VIEW_OPTIONS_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_ON_TIME_WINDOW_LABEL = {
    defaultMessage: 'On-time window',
    id: 'TRIP_ANALYZER.QUERY.ON_TIME_WINDOW_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_ON_TIME_WINDOW_HINT = {
    defaultMessage: 'Schedule deviation inside this range is colored as on time in the timeline.',
    id: 'TRIP_ANALYZER.QUERY.ON_TIME_WINDOW_HINT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_ON_TIME_LOWER_LABEL = {
    defaultMessage: 'Early limit (seconds)',
    id: 'TRIP_ANALYZER.QUERY.ON_TIME_LOWER_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_ON_TIME_UPPER_LABEL = {
    defaultMessage: 'Late limit (seconds)',
    id: 'TRIP_ANALYZER.QUERY.ON_TIME_UPPER_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_SELECT_DATE_PLACEHOLDER = {
    defaultMessage: 'Select date',
    id: 'TRIP_ANALYZER.QUERY.SELECT_DATE_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIME_WINDOW_ALL_DAY_LABEL = {
    defaultMessage: 'All day',
    id: 'TRIP_ANALYZER.QUERY.TIME_WINDOW_ALL_DAY_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIME_WINDOW_START_LABEL = {
    defaultMessage: 'From',
    id: 'TRIP_ANALYZER.QUERY.TIME_WINDOW_START_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIME_WINDOW_END_LABEL = {
    defaultMessage: 'Until',
    id: 'TRIP_ANALYZER.QUERY.TIME_WINDOW_END_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TIME_WINDOW_CLEAR_ACTION = {
    defaultMessage: 'Clear',
    id: 'TRIP_ANALYZER.QUERY.TIME_WINDOW_CLEAR_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SECTION_LABEL = {
    defaultMessage: 'Compare trips',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SECTION_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SECTION_HINT = {
    defaultMessage: 'Compare trips across dates on the same route and direction.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SECTION_HINT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_TOGGLE_LABEL = {
    defaultMessage: 'Compare mode',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_TOGGLE_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_ADD_TRIP_ACTION = {
    defaultMessage: 'Add to comparison',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_ADD_TRIP_DISABLED = {
    defaultMessage: 'Select a trip to add',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_DISABLED',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_ADD_TRIP_OPEN_ACTION = {
    defaultMessage: 'Add trip',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_OPEN_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_ADD_TRIP_DONE_ACTION = {
    defaultMessage: 'Done',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_DONE_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_ADD_TRIP_PANEL_TITLE = {
    defaultMessage: 'Add a trip to comparison',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_PANEL_TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_ADD_TRIP_PANEL_HINT = {
    defaultMessage: 'Change the date, pick a trip, review the preview in the timeline, then add it.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_PANEL_HINT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_ADD_TRIP_PANEL_CLOSE = {
    defaultMessage: 'Close',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_PANEL_CLOSE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_ADD_TRIP_PANEL_PREVIEW_NOTE = {
    defaultMessage: 'A preview row appears in the timeline while this panel is open.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_ADD_TRIP_PANEL_PREVIEW_NOTE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SEARCH_SECTION_LABEL = {
    defaultMessage: 'Add a trip',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SEARCH_SECTION_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_TRIP_MANAGER_LABEL = {
    defaultMessage: 'Comparison set',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_TRIP_MANAGER_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_VISIBILITY_LABEL = {
    defaultMessage: 'Filter visible trips',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_VISIBILITY_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_VISIBILITY_HINT = {
    defaultMessage: 'Choose which compared trips appear in the table. Hidden trips stay in your comparison set.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_VISIBILITY_HINT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_VISIBILITY_PLACEHOLDER = {
    defaultMessage: 'Select trips to show',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_VISIBILITY_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_VISIBILITY_TRIGGER_SINGULAR = {
    defaultMessage: '1 trip',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_VISIBILITY_TRIGGER_SINGULAR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_VISIBILITY_TRIGGER_PLURAL = {
    defaultMessage: '{count} trips',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_VISIBILITY_TRIGGER_PLURAL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SELECT_PLACEHOLDER = {
    defaultMessage: 'No trips in comparison set',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SELECT_PLACEHOLDER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_REMOVE_TRIP_ACTION = {
    defaultMessage: 'Remove from comparison',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_REMOVE_TRIP_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_PREVIEW_SECTION_LABEL = {
    defaultMessage: 'Trip preview',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_PREVIEW_SECTION_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_PREVIEW_NOTE = {
    defaultMessage: 'Preview only — add this trip to include it in the comparison.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_PREVIEW_NOTE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_EDIT_SEARCH_ACTION = {
    defaultMessage: 'Change trip or date',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_EDIT_SEARCH_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_DONE_SEARCH_ACTION = {
    defaultMessage: 'Hide search',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_DONE_SEARCH_ACTION',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SEARCH_CONTEXT_LABEL = {
    defaultMessage: 'Current search',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SEARCH_CONTEXT_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SEARCH_CONTEXT_EMPTY = {
    defaultMessage: 'Select date, route, direction, and trip to search',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SEARCH_CONTEXT_EMPTY',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_ALREADY_IN_SET = {
    defaultMessage: 'Already in comparison',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_ALREADY_IN_SET',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_STAGING_BADGE = {
    defaultMessage: 'Preview',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_STAGING_BADGE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_STAGING_NOTE = {
    defaultMessage: 'This trip is not in your comparison yet. Review the row, then add it.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_STAGING_NOTE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SET_CHIPS_LABEL = {
    defaultMessage: 'Comparison set',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SET_CHIPS_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SET_COUNT_SINGULAR = {
    defaultMessage: 'Comparing 1 trip',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SET_COUNT_SINGULAR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SET_COUNT_PLURAL = {
    defaultMessage: 'Comparing {count} trips',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SET_COUNT_PLURAL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SET_CHIPS_HELPER = {
    defaultMessage: 'Click × on a chip to remove a trip from the comparison.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SET_CHIPS_HELPER',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SET_EMPTY_INLINE = {
    defaultMessage: 'No trips added yet. Search below, preview the trip, then add it to the comparison.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SET_EMPTY_INLINE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SET_EMPTY_TITLE = {
    defaultMessage: 'No trips in comparison set',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SET_EMPTY_TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SET_EMPTY_DETAIL = {
    defaultMessage: 'Use Add a trip above to search, preview your selection below, then add it here.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SET_EMPTY_DETAIL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_EMPTY_STEP_CORRIDOR = {
    defaultMessage: 'Route & direction',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_STEP_CORRIDOR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_EMPTY_STEP_FIRST_TRIP = {
    defaultMessage: 'Add first trip',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_STEP_FIRST_TRIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_EMPTY_STEP_MORE_TRIPS = {
    defaultMessage: 'Add more dates',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_STEP_MORE_TRIPS',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_EMPTY_TITLE_START = {
    defaultMessage: 'Build a comparison',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_TITLE_START',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_EMPTY_TITLE_CORRIDOR = {
    defaultMessage: 'Choose a route and direction',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_TITLE_CORRIDOR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_EMPTY_TITLE_ADD_TRIP = {
    defaultMessage: 'Search and add a trip',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_TITLE_ADD_TRIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_EMPTY_TITLE_MORE_TRIPS = {
    defaultMessage: 'Add trips on other dates',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_TITLE_MORE_TRIPS',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_EMPTY_DETAIL_START = {
    defaultMessage: 'Compare trips across dates on the same route and direction.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_DETAIL_START',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_EMPTY_DETAIL_CORRIDOR = {
    defaultMessage: 'Pick the corridor you want to compare. Route and direction stay fixed after your first trip.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_DETAIL_CORRIDOR',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_EMPTY_DETAIL_ADD_TRIP = {
    defaultMessage: 'Select a date and trip in Add a trip, review the preview row, then click Add to comparison.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_DETAIL_ADD_TRIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_EMPTY_DETAIL_MORE_TRIPS = {
    defaultMessage: 'Change the date, pick another trip, and add it to grow your comparison.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_EMPTY_DETAIL_MORE_TRIPS',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_ALL_HIDDEN_TITLE = {
    defaultMessage: 'All comparison trips hidden',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_ALL_HIDDEN_TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_ALL_HIDDEN_DETAIL = {
    defaultMessage: 'Open table controls and use Filter visible trips to show rows again.',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_ALL_HIDDEN_DETAIL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_CORRIDOR_LOCK_TOOLTIP = {
    defaultMessage: 'Can only compare trips on the same route and direction',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_CORRIDOR_LOCK_TOOLTIP',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_SERVICE_DATE_LABEL = {
    defaultMessage: 'Compare service date (trip B)',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_SERVICE_DATE_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_COMPARE_TRIP_LABEL = {
    defaultMessage: 'Trip B',
    id: 'TRIP_ANALYZER.QUERY.COMPARE_TRIP_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_A_LABEL = {
    defaultMessage: 'Trip A',
    id: 'TRIP_ANALYZER.QUERY.TRIP_A_LABEL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_PERMISSION_DENIED = {
    defaultMessage: 'You do not have permission to view Trip Analyzer data for this agency.',
    id: 'TRIP_ANALYZER.ERRORS.PERMISSION_DENIED',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_NO_TRIP_HISTORY = {
    defaultMessage: 'No observed trip history is available for this agency yet.',
    id: 'TRIP_ANALYZER.ERRORS.NO_TRIP_HISTORY',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_NO_TRIPS_IN_TIME_WINDOW_TITLE = {
    defaultMessage: 'No trips in this time window',
    id: 'TRIP_ANALYZER.TIMELINE.NO_TRIPS_IN_TIME_WINDOW_TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_NO_TRIPS_IN_TIME_WINDOW_DETAIL = {
    defaultMessage: 'No trips depart within the selected time window. Try widening the range or clearing it.',
    id: 'TRIP_ANALYZER.TIMELINE.NO_TRIPS_IN_TIME_WINDOW_DETAIL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_TRIP_CATALOG_ALL_TRIPS_SUBTEXT = {
    defaultMessage: '{count} trips',
    id: 'TRIP_ANALYZER.QUERY.TRIP_CATALOG_ALL_TRIPS_SUBTEXT',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_OFF_CORRIDOR_CELL = {
    defaultMessage: 'Not on this trip\'s corridor on its service date',
    id: 'TRIP_ANALYZER.TIMELINE.OFF_CORRIDOR_CELL',
};

/** @type {import('./copy.utils').CopyEntry} */
export const TRIP_ANALYZER_LEGEND_OFF_CORRIDOR = {
    defaultMessage: 'Not on corridor',
    id: 'TRIP_ANALYZER.TIMELINE.LEGEND_OFF_CORRIDOR',
};

export const TRIP_ANALYZER_COPY = {
    pageTitle: TRIP_ANALYZER_PAGE_TITLE,
    serviceDateLabel: TRIP_ANALYZER_SERVICE_DATE_LABEL,
    routeLabel: TRIP_ANALYZER_ROUTE_LABEL,
    directionLabel: TRIP_ANALYZER_DIRECTION_LABEL,
    tripLabel: TRIP_ANALYZER_TRIP_LABEL,
    partnerLabel: TRIP_ANALYZER_PARTNER_LABEL,
    allPartnersOption: TRIP_ANALYZER_ALL_PARTNERS_OPTION,
    selectRoutePlaceholder: TRIP_ANALYZER_SELECT_ROUTE_PLACEHOLDER,
    selectDirectionPlaceholder: TRIP_ANALYZER_SELECT_DIRECTION_PLACEHOLDER,
    selectTripPlaceholder: TRIP_ANALYZER_SELECT_TRIP_PLACEHOLDER,
    selectPartnerPlaceholder: TRIP_ANALYZER_SELECT_PARTNER_PLACEHOLDER,
    tableControlsLabel: TRIP_ANALYZER_TABLE_CONTROLS_LABEL,
    tableLegendLabel: TRIP_ANALYZER_TABLE_LEGEND_LABEL,
    tableViewOptionsLabel: TRIP_ANALYZER_TABLE_VIEW_OPTIONS_LABEL,
    onTimeWindowLabel: TRIP_ANALYZER_ON_TIME_WINDOW_LABEL,
    onTimeWindowHint: TRIP_ANALYZER_ON_TIME_WINDOW_HINT,
    onTimeLowerLabel: TRIP_ANALYZER_ON_TIME_LOWER_LABEL,
    onTimeUpperLabel: TRIP_ANALYZER_ON_TIME_UPPER_LABEL,
    selectDatePlaceholder: TRIP_ANALYZER_SELECT_DATE_PLACEHOLDER,
    timeWindowAllDayLabel: TRIP_ANALYZER_TIME_WINDOW_ALL_DAY_LABEL,
    timeWindowStartLabel: TRIP_ANALYZER_TIME_WINDOW_START_LABEL,
    timeWindowEndLabel: TRIP_ANALYZER_TIME_WINDOW_END_LABEL,
    timeWindowClearAction: TRIP_ANALYZER_TIME_WINDOW_CLEAR_ACTION,
    compareSectionLabel: TRIP_ANALYZER_COMPARE_SECTION_LABEL,
    compareSectionHint: TRIP_ANALYZER_COMPARE_SECTION_HINT,
    compareToggleLabel: TRIP_ANALYZER_COMPARE_TOGGLE_LABEL,
    compareAddTripAction: TRIP_ANALYZER_COMPARE_ADD_TRIP_ACTION,
    compareAddTripDisabled: TRIP_ANALYZER_COMPARE_ADD_TRIP_DISABLED,
    compareAddTripOpenAction: TRIP_ANALYZER_COMPARE_ADD_TRIP_OPEN_ACTION,
    compareAddTripDoneAction: TRIP_ANALYZER_COMPARE_ADD_TRIP_DONE_ACTION,
    compareAddTripPanelTitle: TRIP_ANALYZER_COMPARE_ADD_TRIP_PANEL_TITLE,
    compareAddTripPanelHint: TRIP_ANALYZER_COMPARE_ADD_TRIP_PANEL_HINT,
    compareAddTripPanelClose: TRIP_ANALYZER_COMPARE_ADD_TRIP_PANEL_CLOSE,
    compareAddTripPanelPreviewNote: TRIP_ANALYZER_COMPARE_ADD_TRIP_PANEL_PREVIEW_NOTE,
    compareSearchSectionLabel: TRIP_ANALYZER_COMPARE_SEARCH_SECTION_LABEL,
    compareTripManagerLabel: TRIP_ANALYZER_COMPARE_TRIP_MANAGER_LABEL,
    compareVisibilityLabel: TRIP_ANALYZER_COMPARE_VISIBILITY_LABEL,
    compareVisibilityHint: TRIP_ANALYZER_COMPARE_VISIBILITY_HINT,
    compareVisibilityPlaceholder: TRIP_ANALYZER_COMPARE_VISIBILITY_PLACEHOLDER,
    compareVisibilityTriggerSingular: TRIP_ANALYZER_COMPARE_VISIBILITY_TRIGGER_SINGULAR,
    compareVisibilityTriggerPlural: TRIP_ANALYZER_COMPARE_VISIBILITY_TRIGGER_PLURAL,
    compareSelectPlaceholder: TRIP_ANALYZER_COMPARE_SELECT_PLACEHOLDER,
    compareRemoveTripAction: TRIP_ANALYZER_COMPARE_REMOVE_TRIP_ACTION,
    comparePreviewSectionLabel: TRIP_ANALYZER_COMPARE_PREVIEW_SECTION_LABEL,
    comparePreviewNote: TRIP_ANALYZER_COMPARE_PREVIEW_NOTE,
    compareEditSearchAction: TRIP_ANALYZER_COMPARE_EDIT_SEARCH_ACTION,
    compareDoneSearchAction: TRIP_ANALYZER_COMPARE_DONE_SEARCH_ACTION,
    compareSearchContextLabel: TRIP_ANALYZER_COMPARE_SEARCH_CONTEXT_LABEL,
    compareSearchContextEmpty: TRIP_ANALYZER_COMPARE_SEARCH_CONTEXT_EMPTY,
    compareAlreadyInSet: TRIP_ANALYZER_COMPARE_ALREADY_IN_SET,
    compareStagingBadge: TRIP_ANALYZER_COMPARE_STAGING_BADGE,
    compareStagingNote: TRIP_ANALYZER_COMPARE_STAGING_NOTE,
    compareSetChipsLabel: TRIP_ANALYZER_COMPARE_SET_CHIPS_LABEL,
    compareSetCountSingular: TRIP_ANALYZER_COMPARE_SET_COUNT_SINGULAR,
    compareSetCountPlural: TRIP_ANALYZER_COMPARE_SET_COUNT_PLURAL,
    compareSetChipsHelper: TRIP_ANALYZER_COMPARE_SET_CHIPS_HELPER,
    compareSetEmptyInline: TRIP_ANALYZER_COMPARE_SET_EMPTY_INLINE,
    compareEmptyStepCorridor: TRIP_ANALYZER_COMPARE_EMPTY_STEP_CORRIDOR,
    compareEmptyStepFirstTrip: TRIP_ANALYZER_COMPARE_EMPTY_STEP_FIRST_TRIP,
    compareEmptyStepMoreTrips: TRIP_ANALYZER_COMPARE_EMPTY_STEP_MORE_TRIPS,
    compareEmptyTitleStart: TRIP_ANALYZER_COMPARE_EMPTY_TITLE_START,
    compareEmptyTitleCorridor: TRIP_ANALYZER_COMPARE_EMPTY_TITLE_CORRIDOR,
    compareEmptyTitleAddTrip: TRIP_ANALYZER_COMPARE_EMPTY_TITLE_ADD_TRIP,
    compareEmptyTitleMoreTrips: TRIP_ANALYZER_COMPARE_EMPTY_TITLE_MORE_TRIPS,
    compareEmptyDetailStart: TRIP_ANALYZER_COMPARE_EMPTY_DETAIL_START,
    compareEmptyDetailCorridor: TRIP_ANALYZER_COMPARE_EMPTY_DETAIL_CORRIDOR,
    compareEmptyDetailAddTrip: TRIP_ANALYZER_COMPARE_EMPTY_DETAIL_ADD_TRIP,
    compareEmptyDetailMoreTrips: TRIP_ANALYZER_COMPARE_EMPTY_DETAIL_MORE_TRIPS,
    compareSetEmptyTitle: TRIP_ANALYZER_COMPARE_SET_EMPTY_TITLE,
    compareSetEmptyDetail: TRIP_ANALYZER_COMPARE_SET_EMPTY_DETAIL,
    compareAllHiddenTitle: TRIP_ANALYZER_COMPARE_ALL_HIDDEN_TITLE,
    compareAllHiddenDetail: TRIP_ANALYZER_COMPARE_ALL_HIDDEN_DETAIL,
    compareCorridorLockTooltip: TRIP_ANALYZER_COMPARE_CORRIDOR_LOCK_TOOLTIP,
    compareServiceDateLabel: TRIP_ANALYZER_COMPARE_SERVICE_DATE_LABEL,
    compareTripLabel: TRIP_ANALYZER_COMPARE_TRIP_LABEL,
    tripALabel: TRIP_ANALYZER_TRIP_A_LABEL,
    permissionDenied: TRIP_ANALYZER_PERMISSION_DENIED,
    noTripHistory: TRIP_ANALYZER_NO_TRIP_HISTORY,
    noTripsInTimeWindowTitle: TRIP_ANALYZER_NO_TRIPS_IN_TIME_WINDOW_TITLE,
    noTripsInTimeWindowDetail: TRIP_ANALYZER_NO_TRIPS_IN_TIME_WINDOW_DETAIL,
    tripCatalogAllTripsSubtext: TRIP_ANALYZER_TRIP_CATALOG_ALL_TRIPS_SUBTEXT,
    offCorridorCell: TRIP_ANALYZER_OFF_CORRIDOR_CELL,
    legendOffCorridor: TRIP_ANALYZER_LEGEND_OFF_CORRIDOR,
};

export const getTripAnalyzerPageTitle = () => copyText(TRIP_ANALYZER_PAGE_TITLE);
export const getTripAnalyzerServiceDateLabel = () => copyText(TRIP_ANALYZER_SERVICE_DATE_LABEL);
export const getTripAnalyzerRouteLabel = () => copyText(TRIP_ANALYZER_ROUTE_LABEL);
export const getTripAnalyzerDirectionLabel = () => copyText(TRIP_ANALYZER_DIRECTION_LABEL);
export const getTripAnalyzerTripLabel = () => copyText(TRIP_ANALYZER_TRIP_LABEL);
export const getTripAnalyzerPartnerLabel = () => copyText(TRIP_ANALYZER_PARTNER_LABEL);
